/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiScenarioContentForValidation,
    InternalApiScenarioContentForValidationFromJSON,
    InternalApiScenarioContentForValidationToJSON,
    InternalApiScenarioValidationResult,
    InternalApiScenarioValidationResultFromJSON,
    InternalApiScenarioValidationResultToJSON,
    InternalApiScenarioVersion,
    InternalApiScenarioVersionFromJSON,
    InternalApiScenarioVersionToJSON,
    InternalApiScenarioVersionCommand,
    InternalApiScenarioVersionCommandFromJSON,
    InternalApiScenarioVersionCommandToJSON,
} from '../models';

export interface CreateScenarioVersionRequest {
    scenarioId: string;
    internalApiScenarioVersionCommand: InternalApiScenarioVersionCommand;
}

export interface DeleteScenarioVersionRequest {
    scenarioId: string;
    id: string;
}

export interface DuplicateScenarioVersionRequest {
    scenarioId: string;
    id: string;
}

export interface GetScenarioVersionRequest {
    scenarioId: string;
    id: string;
}

export interface UpdateScenarioVersionRequest {
    scenarioId: string;
    id: string;
    internalApiScenarioVersionCommand: InternalApiScenarioVersionCommand;
}

export interface ValidateScenarioContentRequest {
    scenarioId: string;
    internalApiScenarioContentForValidation: InternalApiScenarioContentForValidation;
}

export interface ValidateScenarioContentAgainstEntityRequest {
    scenarioId: string;
    entityId: string;
    internalApiScenarioContentForValidation: InternalApiScenarioContentForValidation;
}

/**
 * 
 */
export class ScenarioVersionInternalApi extends runtime.BaseAPI {

    /**
     * Create scenario version
     */
    async createScenarioVersionRaw(requestParameters: CreateScenarioVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioVersion>> {
        if (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined) {
            throw new runtime.RequiredError('scenarioId','Required parameter requestParameters.scenarioId was null or undefined when calling createScenarioVersion.');
        }

        if (requestParameters.internalApiScenarioVersionCommand === null || requestParameters.internalApiScenarioVersionCommand === undefined) {
            throw new runtime.RequiredError('internalApiScenarioVersionCommand','Required parameter requestParameters.internalApiScenarioVersionCommand was null or undefined when calling createScenarioVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioId}/versions`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScenarioVersionCommandToJSON(requestParameters.internalApiScenarioVersionCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioVersionFromJSON(jsonValue));
    }

    /**
     * Create scenario version
     */
    async createScenarioVersion(requestParameters: CreateScenarioVersionRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioVersion> {
        const response = await this.createScenarioVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete scenario version
     */
    async deleteScenarioVersionRaw(requestParameters: DeleteScenarioVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined) {
            throw new runtime.RequiredError('scenarioId','Required parameter requestParameters.scenarioId was null or undefined when calling deleteScenarioVersion.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteScenarioVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioId}/versions/{id}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete scenario version
     */
    async deleteScenarioVersion(requestParameters: DeleteScenarioVersionRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteScenarioVersionRaw(requestParameters, initOverrides);
    }

    /**
     * Duplicate scenario version
     */
    async duplicateScenarioVersionRaw(requestParameters: DuplicateScenarioVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioVersion>> {
        if (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined) {
            throw new runtime.RequiredError('scenarioId','Required parameter requestParameters.scenarioId was null or undefined when calling duplicateScenarioVersion.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling duplicateScenarioVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioId}/versions/{id}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioVersionFromJSON(jsonValue));
    }

    /**
     * Duplicate scenario version
     */
    async duplicateScenarioVersion(requestParameters: DuplicateScenarioVersionRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioVersion> {
        const response = await this.duplicateScenarioVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get scenario version
     */
    async getScenarioVersionRaw(requestParameters: GetScenarioVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioVersion>> {
        if (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined) {
            throw new runtime.RequiredError('scenarioId','Required parameter requestParameters.scenarioId was null or undefined when calling getScenarioVersion.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getScenarioVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioId}/versions/{id}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioVersionFromJSON(jsonValue));
    }

    /**
     * Get scenario version
     */
    async getScenarioVersion(requestParameters: GetScenarioVersionRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioVersion> {
        const response = await this.getScenarioVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update scenario version
     */
    async updateScenarioVersionRaw(requestParameters: UpdateScenarioVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioVersion>> {
        if (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined) {
            throw new runtime.RequiredError('scenarioId','Required parameter requestParameters.scenarioId was null or undefined when calling updateScenarioVersion.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateScenarioVersion.');
        }

        if (requestParameters.internalApiScenarioVersionCommand === null || requestParameters.internalApiScenarioVersionCommand === undefined) {
            throw new runtime.RequiredError('internalApiScenarioVersionCommand','Required parameter requestParameters.internalApiScenarioVersionCommand was null or undefined when calling updateScenarioVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioId}/versions/{id}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScenarioVersionCommandToJSON(requestParameters.internalApiScenarioVersionCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioVersionFromJSON(jsonValue));
    }

    /**
     * Update scenario version
     */
    async updateScenarioVersion(requestParameters: UpdateScenarioVersionRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioVersion> {
        const response = await this.updateScenarioVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate scenario content
     */
    async validateScenarioContentRaw(requestParameters: ValidateScenarioContentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined) {
            throw new runtime.RequiredError('scenarioId','Required parameter requestParameters.scenarioId was null or undefined when calling validateScenarioContent.');
        }

        if (requestParameters.internalApiScenarioContentForValidation === null || requestParameters.internalApiScenarioContentForValidation === undefined) {
            throw new runtime.RequiredError('internalApiScenarioContentForValidation','Required parameter requestParameters.internalApiScenarioContentForValidation was null or undefined when calling validateScenarioContent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioId}/validate-content`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScenarioContentForValidationToJSON(requestParameters.internalApiScenarioContentForValidation),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate scenario content
     */
    async validateScenarioContent(requestParameters: ValidateScenarioContentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.validateScenarioContentRaw(requestParameters, initOverrides);
    }

    /**
     * Validate scenario content against an entity
     */
    async validateScenarioContentAgainstEntityRaw(requestParameters: ValidateScenarioContentAgainstEntityRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioValidationResult>> {
        if (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined) {
            throw new runtime.RequiredError('scenarioId','Required parameter requestParameters.scenarioId was null or undefined when calling validateScenarioContentAgainstEntity.');
        }

        if (requestParameters.entityId === null || requestParameters.entityId === undefined) {
            throw new runtime.RequiredError('entityId','Required parameter requestParameters.entityId was null or undefined when calling validateScenarioContentAgainstEntity.');
        }

        if (requestParameters.internalApiScenarioContentForValidation === null || requestParameters.internalApiScenarioContentForValidation === undefined) {
            throw new runtime.RequiredError('internalApiScenarioContentForValidation','Required parameter requestParameters.internalApiScenarioContentForValidation was null or undefined when calling validateScenarioContentAgainstEntity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioId}/validate-content/{entityId}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))).replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters.entityId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScenarioContentForValidationToJSON(requestParameters.internalApiScenarioContentForValidation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioValidationResultFromJSON(jsonValue));
    }

    /**
     * Validate scenario content against an entity
     */
    async validateScenarioContentAgainstEntity(requestParameters: ValidateScenarioContentAgainstEntityRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioValidationResult> {
        const response = await this.validateScenarioContentAgainstEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
